export const menuIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 6h16M4 12h16M4 18h16"
    />
  </svg>
);

export const atIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
    />
  </svg>
);

export const starSolidIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 576 512"
    fill="currentColor"
    stroke="currentColor"
  >
    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
  </svg>
);

export const starOutlineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 576 512"
    fill="currentColor"
    stroke="currentColor"
  >
    <path d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z" />
  </svg>
);

export const settingIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
    />
  </svg>
);

export const approvedIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
      clipRule="evenodd"
    />
  </svg>
);

export const closeModalIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="25"
    width="25"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

export const downloadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"
    />
  </svg>
);

export const checkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fill-rule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clip-rule="evenodd"
    />
  </svg>
);

export const mIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="currentColor"
  >
    <path
      d="M23.6,17L23.6,17c-1.2-0.2-1.8-1.5-1.8-3.8c0-0.7,0.1-1.7,0.3-3.1c0.3-1.9,0.6-2.6,0.8-2.9l0-0.1
	l0-0.1c-0.1-0.3-0.5-0.7-2.8-0.7h0c-0.3,0.1-0.7,0.3-0.7,0.9c0,0.3,0,0.5,0,0.7c0,0.1,0,0.3,0,0.3c-0.4,1.3-1.2,2.7-2.1,4.3
	c-1.5,2.5-2,2.7-2.2,2.7c-0.5,0-1-0.7-1.3-2.1c-0.2-0.6-0.3-1.3-0.4-2s-0.1-1.4-0.1-2.2c0-1.4,0.2-1.9,0.3-2.1l0.1-0.2l-0.2-0.1
	c-0.9-0.4-1.6-0.6-2-0.6c-1,0-1.3,0.5-1.3,1c0,1.1-0.4,2.4-1.3,4c-0.8,1.5-1.7,2.8-2.8,3.8c-0.3,0.3-0.6,0.6-1,0.7v0l-0.2,0.1
	c-0.6,0.3-1.1,0.4-1.5,0.4c-0.2,0-0.5,0-0.8,0S1.5,15.9,1,15.9l0,0l-0.8,0.3l0.2,0.2c0.8,0.6,1.7,0.9,2.7,0.9c2.7,0,5-1.8,7-5.4
	c0.3-0.6,0.6-1.1,0.8-1.4c0.3,1.3,0.4,1.6,0.4,1.7c0.1,0.3,0.1,0.5,0.1,0.6c0,0.2,0,0.3,0.1,0.4v0c0.7,2.3,1.7,3.4,3.3,3.4
	c1.3,0,2.5-1.1,3.7-3.3l0.3-0.5c0.3-0.5,0.5-1,0.7-1.4c0.1-0.2,0.2-0.4,0.3-0.6l0,0.1c0,0.1,0,0.3,0,0.5c0,0.2,0,0.5,0,0.6v0.4
	c0,1,0.2,2,0.5,3c0.6,1.6,1.5,2.5,2.7,2.5c0.3,0,0.6-0.2,0.9-0.5l0.1-0.1L23.6,17z"
    />
  </svg>
);
export const plusIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
      clipRule="evenodd"
    />
  </svg>
);
export const photoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>
);
export const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

export const searchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

export const listIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 6h16M4 10h16M4 14h16M4 18h16"
    />
  </svg>
);

/////// CSI UTILITY LOGO

export const utilityLogoAsiatan = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 105 50"
    width="105"
    height="60"
  >
    <g id="_x3C_Group_x3E_">
      <g id="csi-logo-bottom">
        <path
          className="st0"
          d="M31.5,24.9c-1.3,0.6-2.8,0.9-4.5,0.9c-1.6,0-3-0.3-4.3-0.8c-1.3-0.5-2.5-1.2-3.4-2.2c-1-0.9-1.7-2.1-2.3-3.4
			c-0.6-1.3-0.8-2.8-0.8-4.3c0-1.6,0.3-3.1,0.8-4.4c0.6-1.3,1.3-2.4,2.3-3.4c1-0.9,2.2-1.6,3.5-2.1C24,4.7,25.5,4.5,27,4.5
			c1.4,0,2.8,0.3,4.2,0.8s2.5,1.2,3.4,2.2l-3.3,3.3c-0.5-0.6-1.1-1.1-1.8-1.4c-0.7-0.3-1.5-0.5-2.3-0.5c-0.9,0-1.6,0.2-2.4,0.5
			c-0.7,0.3-1.3,0.7-1.8,1.3c-0.5,0.6-0.9,1.2-1.2,2c-0.3,0.8-0.4,1.6-0.4,2.5c0,0.9,0.1,1.8,0.4,2.5c0.3,0.8,0.7,1.4,1.2,2
			c0.5,0.5,1.1,1,1.8,1.3c0.7,0.3,1.5,0.5,2.3,0.5c1,0,1.8-0.2,2.5-0.6c0.7-0.4,1.3-0.9,1.7-1.5l3.4,3.2
			C33.9,23.5,32.8,24.3,31.5,24.9z"
        />
        <path
          className="st0"
          d="M47.6,10.3c-0.4-0.5-1-1-1.6-1.3c-0.7-0.3-1.3-0.5-2-0.5c-0.3,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3
			c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2,0.3-0.3,0.6-0.3,1c0,0.3,0.1,0.6,0.2,0.9c0.1,0.2,0.4,0.4,0.6,0.6c0.3,0.2,0.6,0.3,1,0.5
			c0.4,0.1,0.8,0.3,1.3,0.4c0.7,0.2,1.4,0.5,2.1,0.8c0.7,0.3,1.4,0.6,2,1.1c0.6,0.5,1.1,1,1.5,1.7c0.4,0.7,0.6,1.5,0.6,2.5
			c0,1.2-0.2,2.2-0.6,3c-0.4,0.8-1,1.6-1.7,2.1c-0.7,0.6-1.6,1-2.5,1.2c-0.9,0.3-1.9,0.4-2.9,0.4c-1.4,0-2.9-0.3-4.2-0.8
			c-1.4-0.5-2.5-1.2-3.4-2.2l3.2-3.3c0.5,0.6,1.1,1.1,2,1.5c0.8,0.4,1.6,0.6,2.4,0.6c0.4,0,0.7,0,1.1-0.1c0.3-0.1,0.6-0.2,0.9-0.4
			c0.3-0.2,0.5-0.4,0.6-0.7c0.2-0.3,0.2-0.6,0.2-1c0-0.4-0.1-0.7-0.3-1c-0.2-0.3-0.5-0.5-0.8-0.7c-0.4-0.2-0.8-0.4-1.3-0.6
			c-0.5-0.2-1.1-0.4-1.8-0.6c-0.6-0.2-1.3-0.5-1.9-0.7c-0.6-0.3-1.2-0.7-1.7-1.1c-0.5-0.4-0.9-1-1.2-1.6c-0.3-0.6-0.4-1.4-0.4-2.3
			c0-1.1,0.2-2.1,0.7-2.9c0.5-0.8,1.1-1.5,1.8-2c0.7-0.5,1.6-0.9,2.5-1.1c0.9-0.2,1.9-0.4,2.8-0.4c1.1,0,2.3,0.2,3.5,0.6
			c1.2,0.4,2.2,1,3.1,1.9L47.6,10.3z"
        />
        <path className="st0" d="M53.8,25.3V5h4.9v20.3H53.8z" />
      </g>
      <g id="csi-logo-bottom">
        <path
          className="st0"
          d="M33.5,41.3c-0.4,1-1,1.9-1.8,2.6c-0.8,0.7-1.7,1.3-2.8,1.7c-1.1,0.4-2.3,0.6-3.6,0.6c-1.3,0-2.5-0.2-3.6-0.6
			c-1.1-0.4-2-1-2.7-1.7s-1.3-1.6-1.7-2.6c-0.4-1-0.6-2.1-0.6-3.3V25.3h4.9v12.2c0,0.6,0.1,1.1,0.2,1.6c0.1,0.5,0.4,0.9,0.7,1.3
			c0.3,0.4,0.7,0.7,1.2,0.9c0.5,0.2,1.1,0.3,1.8,0.3s1.3-0.1,1.8-0.3c0.5-0.2,0.9-0.5,1.2-0.9c0.3-0.4,0.5-0.8,0.7-1.3
			c0.1-0.5,0.2-1,0.2-1.6V25.3h4.9v12.6C34.1,39.1,33.9,40.3,33.5,41.3z"
        />
        <path
          className="st0"
          d="M42.9,34.8v5.5c0,0.7,0.1,1.2,0.4,1.5c0.3,0.3,0.7,0.5,1.4,0.5c0.2,0,0.5,0,0.7-0.1c0.3,0,0.5-0.1,0.6-0.2
			l0.1,3.4c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-1,0.1-1.5,0.1c-1,0-1.8-0.1-2.4-0.4c-0.6-0.2-1.2-0.6-1.6-1c-0.4-0.4-0.7-1-0.8-1.6
			c-0.2-0.6-0.3-1.3-0.3-2.1v-6h-2.3v-3.5h2.3v-3.7h4.6v3.7h3.3v3.5H42.9z"
        />
        <path
          className="st0"
          d="M53.6,26.8c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.2,0.2-0.5,0.4-0.9,0.5c-0.3,0.1-0.7,0.2-1,0.2
			c-0.8,0-1.4-0.3-1.9-0.8c-0.5-0.5-0.8-1.1-0.8-1.8c0-0.3,0.1-0.7,0.2-1c0.1-0.3,0.3-0.6,0.6-0.8c0.2-0.2,0.5-0.4,0.9-0.6
			c0.3-0.1,0.7-0.2,1.1-0.2c0.4,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8C53.5,26.1,53.6,26.4,53.6,26.8z
			 M48.5,45.6V31.3h4.7v14.2H48.5z"
        />
        <path className="st0" d="M57,45.6V23.9h4.8v21.6H57z" />
        <path
          className="st0"
          d="M70.6,26.8c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.2,0.2-0.5,0.4-0.9,0.5c-0.3,0.1-0.7,0.2-1,0.2
			c-0.8,0-1.4-0.3-1.9-0.8c-0.5-0.5-0.8-1.1-0.8-1.8c0-0.3,0.1-0.7,0.2-1c0.1-0.3,0.3-0.6,0.6-0.8c0.2-0.2,0.5-0.4,0.9-0.6
			c0.3-0.1,0.7-0.2,1.1-0.2c0.4,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8C70.5,26.1,70.6,26.4,70.6,26.8z
			 M65.5,45.6V31.3h4.7v14.2H65.5z"
        />
        <path
          className="st0"
          d="M79,34.8v5.5c0,0.7,0.1,1.2,0.4,1.5c0.3,0.3,0.7,0.5,1.4,0.5c0.2,0,0.5,0,0.7-0.1c0.3,0,0.5-0.1,0.6-0.2
			l0.1,3.4c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-1,0.1-1.5,0.1c-1,0-1.8-0.1-2.4-0.4c-0.6-0.2-1.2-0.6-1.6-1c-0.4-0.4-0.7-1-0.8-1.6
			c-0.2-0.6-0.3-1.3-0.3-2.1v-6h-2.3v-3.5h2.3v-3.7H79v3.7h3.3v3.5H79z"
        />
        <path
          className="st0"
          d="M92.6,47.7c-0.3,0.7-0.6,1.4-1,2c-0.4,0.6-0.8,1.1-1.3,1.5c-0.5,0.4-1.1,0.7-1.7,0.9
			c-0.7,0.2-1.4,0.3-2.3,0.3c-0.4,0-0.9,0-1.4-0.1c-0.5-0.1-0.9-0.1-1.2-0.2l0.5-3.9c0.2,0.1,0.5,0.1,0.8,0.2c0.3,0,0.5,0.1,0.8,0.1
			c0.7,0,1.2-0.2,1.6-0.5c0.3-0.3,0.6-0.8,0.8-1.4l0.5-1.2l-6-14h5.2l3.2,9.2h0.1l2.8-9.2h5L92.6,47.7z"
        />
      </g>
    </g>
    <g id="csi-logo-asiatan">
      <path
        id="XMLID_68_"
        d="M8.2,35.5c-0.5,0-0.9-0.2-1.2-0.4c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2-0.1-0.3-0.1-0.5,0
		c0.1,0.4,0.3,0.7,0.6,0.9c0.6,0.6,1.3,1.1,1.9,1.7c0.2-0.3,0.3-0.6,0.3-0.9c0,0,0-0.1,0-0.1c0.3-0.7,0.6-1.4,1.1-2
		c0.3-0.4,0.7-0.7,1.1-0.9c0,0,0.1,0,0.1,0c0.2,0.1,0.4,0.1,0.7,0.1c-0.2,0.2-0.1,0.3,0,0.3c0.3,0.3,0.5,0.6,0.6,1.1
		c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2,0,0.3c0,0,0,0.1,0,0.1c-0.1,0.2,0,0.4-0.1,0.6c0,0,0,0.1,0,0.1c0.2,0.6-0.1,1.3-0.5,1.8
		c-0.5,0.6-1.1,0.9-1.8,1c-0.2,0-0.3,0-0.4-0.1c0.2-0.1,0.4-0.2,0.5-0.2c0.7-0.4,1-0.9,1.1-1.6c0.1-1.1-0.3-1.8-0.9-2.4c0,0,0,0,0,0
		c-0.1,0.3-0.2,0.6-0.4,0.9c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.1,0,0.2c0,0,0,0.1,0,0.1c-0.1,0.2,0,0.4-0.2,0.6
		c0,0.1-0.1,0.1,0,0.2c0,0.1,0,0.2-0.1,0.3c-0.4,0.8-1.2,1.3-1.9,1.2c-0.4-0.1-0.8-0.3-1.1-0.5c-0.8-0.5-1.4-1.2-2.1-1.8
		c0,0-0.1-0.1,0-0.2c0.6-0.9,1.2-1.8,2-2.6c0,0,0.1-0.1,0.1-0.1C6.3,33,6.4,33,6.5,33c0.3,0.1,0.5,0.2,0.8,0.3c0,0,0.1,0,0.1,0.1
		c-0.1,0.5,0.2,0.7,0.5,0.8c0.1,0,0.1,0,0.1,0.1c-0.1,0.1,0,0.2,0,0.2c0.1,0,0.1,0.1,0,0.2c-0.1,0.1,0,0.1,0,0.2
		C8.1,35.1,8.1,35.3,8.2,35.5z"
      />
      <path
        id="XMLID_67_"
        d="M3,28.5c0,0.1,0,0.2,0,0.3c0,0.2,0,0.4,0.2,0.4c0.1,0,0.1,0.1,0,0.2c0,0.1-0.1,0.2-0.1,0.3
		C3,29.9,2.9,30,3.1,30c0.1,0,0.1,0.1,0.1,0.2c0,0.2,0,0.4,0,0.6c0,0.1,0,0.1-0.1,0.1c-0.7-0.1-1.4-0.4-1.8-1
		c-0.2-0.3-0.2-0.4,0.2-0.7c0.3-0.3,0.6-0.5,0.9-0.8C2.6,28.1,3,28.1,3,28.5z"
      />
      <path
        id="XMLID_64_"
        d="M7.3,1.2c0.9,1.1,1.9,2.2,2.9,3.3c0,0,0.1,0,0,0.1c-0.1,0.1-0.1,0-0.2,0C9.4,4.4,8.7,4.2,8,3.9
		C7.6,3.7,7.2,3.5,6.9,3.1c0,0-0.1,0-0.1,0C6.6,3.1,6.5,3,6.4,2.9C6.3,2.8,6.3,2.7,6.2,2.6c-0.1-0.1-0.4-0.1-0.5,0
		c-0.4,0.4-0.8,0.9-1,1.5c-0.1,0.2-0.1,0.4,0,0.6C4.7,4.8,4.8,5,5,5.1c0.5,0.6,1.1,1,1.8,1.5c0.5,0.4,1,0.8,1.5,1.2c0,0,0.1,0,0,0.2
		C8.2,8.1,8.2,8,8.1,8C7.8,7.9,7.6,7.7,7.3,7.6C7.2,7.6,7.1,7.4,7,7.5c-0.2,0.1-0.3,0-0.4-0.2C6.6,7.2,6.5,7.1,6.4,7
		C6.2,7,6.1,7,6,6.9C5.9,6.8,5.9,6.7,5.8,6.7c-0.2,0-0.3-0.1-0.3-0.2C5.4,6.4,5.3,6.3,5.2,6.3C5,6.1,4.8,6,4.7,5.8
		c-0.1-0.2-0.2-0.2-0.4,0C4.2,5.9,4.1,6,4,6.1C3.7,6.5,3.5,6.8,3.3,7.2c-0.1,0.1-0.1,0.2,0,0.2C4.1,7.7,4.9,8,5.7,8.2
		c0.4,0.2,0.9,0.2,1.2,0.5c1.3,1,2.7,1.8,4.1,2.6c0,0,0.1,0,0.1,0.1c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.1-0.1
		c0-0.1-0.1-0.1-0.2,0c-0.1,0.1-0.2,0.1-0.2,0c0,0,0-0.1-0.1,0c-0.3,0.1-0.5-0.1-0.7-0.2c-0.1-0.1-0.3-0.1-0.5,0
		c-0.2,0.1-0.3,0-0.4-0.1c-0.1-0.2-0.2-0.2-0.4-0.2c-0.1,0-0.2,0-0.3-0.1c-0.5-0.3-1.1-0.4-1.6-0.8C6.5,10,6.4,9.9,6.3,9.9
		C6.1,9.8,5.9,9.7,5.8,9.5c0-0.1-0.1,0-0.2,0c-0.5,0.3-0.7,0.7-0.9,1.2c-0.1,0.2,0,0.3,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.2
		c0.4,0.2,0.4,0.1,0.1,0.7c-0.3,0.5-0.6,0.9-0.9,1.4c-0.2,0.4-0.2,0.8,0,1c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.3
		c0.7,0.5,1.6,0.8,2.4,1c0.1,0,0.1,0,0.2,0.1c0.4,0.5,0.8,0.9,1.2,1.4c0,0,0.1,0,0,0.1c-0.1,0.1,0,0.1,0,0.1
		c0.2,0.2,0.5,0.3,0.6,0.7c0,0,0,0,0,0c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.1,0.2,0.3,0.4,0.4c0.1,0,0.1,0,0.2,0.1c0.3,0.3,0.6,0.5,1,0.8
		c0,0,0.1,0,0.1,0.1c0,0.1-0.1,0.1-0.2,0.1c-0.4,0-0.8,0-1.1,0c-0.1,0-0.2,0-0.2,0.1c0,0.1,0,0.2-0.1,0.2c-0.1,0-0.2,0.1-0.1-0.1
		c0-0.1,0,0-0.1,0C9.4,20.1,9,20,8.5,19.9c-0.2,0-0.4,0-0.5,0.1c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.3-0.2-0.6-0.2
		c0.2-0.1,0.2-0.1,0.1-0.2c0-0.1-0.1-0.2-0.3-0.2c-0.1,0-0.2-0.1-0.3-0.2c0-0.1-0.1-0.1-0.3-0.1c-0.1,0-0.2,0-0.2,0
		c-0.1,0-0.3,0.1-0.4-0.1c-0.1-0.1-0.1-0.3-0.3-0.1c-0.1,0,0,0-0.1-0.1c0-0.6-0.2-1.2-0.3-1.8c0,0,0-0.1,0-0.1
		c-0.1,0.1-0.1,0-0.1-0.1c-0.1-0.4-0.1-0.8-0.2-1.2c-0.1,0.1-0.1,0.2-0.1,0.2c0.1,0.5,0.1,1-0.1,1.5c0,0.1,0,0.2,0,0.3
		c0.1,0.1,0.1,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1c0.1,0.1,0,0.3,0,0.5c-0.1,0-0.2,0-0.2-0.1c0-0.1-0.1-0.1-0.2-0.2
		c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0,0-0.1c0.2-0.1,0-0.1,0-0.1c-0.4-0.2-0.8-0.5-1.1-0.9c0-0.1-0.1,0-0.1,0c-0.3,0.2-0.7,0.5-1,0.8
		c-0.4,0.4-0.7,0.9-0.8,1.4c0,0.1,0,0.2,0.1,0.2c0.9,0.4,1.9,0.7,2.9,0.9c0.4,0.1,0.5,0.3,0.5,0.7c0,0.1,0,0.2,0,0.3
		c0,0.4,0,0.8,0,1.3c0,0.1,0,0.2,0.1,0.1c0,0,0.1,0,0.1,0c0.4,0,0.8-0.2,1.2-0.6c0.1-0.1,0.1-0.2,0.1-0.3c-0.1-0.1-0.1-0.2-0.1-0.4
		c0.1-0.2,0.1-0.4-0.2-0.4c-0.1,0-0.1-0.1-0.2-0.1c0,0,0-0.1,0-0.1c0-0.1,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0c0,0,0.1,0,0.1,0
		c-0.1,0.1,0,0.1,0,0.1c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c1.4,0.2,2.9,0.2,4.4,0.1c0.2,0,0.4,0,0.6-0.1c0.5-0.2,0.9-0.6,1.2-1.1
		c0.2-0.3,0.1-0.5,0-0.7C12.2,19.1,12,19,11.7,19c0,0,0,0-0.1,0c-0.1,0.1-0.1,0.1-0.2,0c-1.1-0.9-2.2-1.8-3.2-2.8c0,0-0.1,0-0.1-0.1
		c0,0,0.1,0,0.1,0c0.9,0.2,1.7,0.3,2.6,0.3c0.4,0,0.7-0.2,0.8-0.6c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.2-0.4,0-0.5
		c-0.7-0.5-1.4-0.9-2.1-1.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.3-0.1-0.4-0.3c0-0.1-0.1-0.1-0.1-0.1c-0.4-0.1-0.8-0.4-1.1-0.8
		c0,0-0.1,0,0-0.1c0.3,0,0.6,0,0.8,0.1c0.5,0.1,1,0.2,1.6,0.2c0.1,0,0.1,0,0.1,0c0.5,0.2,1.1,0,1.7-0.4c0.3-0.2,0.4-0.7,0.2-0.9
		c-0.2-0.1-0.4-0.2-0.6-0.4c-1-0.6-2-1.2-2.9-1.8c0,0,0,0,0,0c0,0,0,0,0.1,0c0.4,0.1,0.8,0.2,1.2,0.3c0.6,0.1,1.2,0.1,1.8,0
		c0.2,0,0.3-0.2,0.4-0.4c0.1-0.2,0-0.3-0.2-0.3c-0.2,0-0.4,0-0.5-0.1C10.7,8.4,10.3,8.2,9.9,8C8.4,7.3,7.2,6.3,5.9,5.3
		C5.8,5.2,5.7,5.1,5.5,5c0.1,0,0.1,0,0.2,0C6.9,5.1,8,5.4,9.1,5.6c0.6,0.1,1.3,0.1,2,0c0.4-0.1,0.9-0.5,0.9-1c0-0.2-0.1-0.2-0.2-0.1
		c-0.1,0.1-0.2,0.1-0.3,0C10.8,4,10,3.5,9.4,2.8C8.9,2.3,8.3,1.7,7.7,1.2C7.6,1.1,7.5,1,7.3,1c0,0,0,0,0,0C7.2,1.1,7.3,1.2,7.3,1.2z
		 M8.2,13.3c0.9,0.7,1.7,1.4,2.7,2c0,0,0.1,0,0.1,0.1c-0.2,0-0.4,0-0.6,0c-0.6-0.1-1.2-0.4-1.8-0.6c-0.2-0.1-0.4-0.2-0.6-0.3
		c-0.2-0.2-0.4-0.3-0.6-0.4c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.4-0.2-0.7-0.3c-0.3-0.1-0.5-0.3-0.6-0.5c0,0,0,0,0,0
		c0.1-0.3,0.1-0.6,0.3-0.9c0.1-0.1,0.1,0,0.1,0C6.7,12.2,7.5,12.7,8.2,13.3z"
      />
      <path
        id="XMLID_61_"
        d="M1.9,39.4c-0.2,0.3-0.4,0.7-0.6,1c-0.2,0.4-0.4,0.7-0.6,1c-0.2,0.3-0.3,0.5-0.4,0.8c0,0.1,0,0.1,0.1,0.2
		c0.5,0.1,0.8,0.4,1.2,0.6c0.5,0.4,1.1,0.8,1.8,1c0,0,0.1,0,0.1,0c0,0.1,0,0.1,0.1,0.2c1.6,1,3.3,1.9,4.9,2.8c0.4,0.2,0.5,0.5,0.5,1
		c0,0.3,0,0.7,0,1c0,0.3,0.1,0.5,0,0.8c0,0,0,0.1,0,0.1C9.2,50,9.3,50,9.3,49.9c0.3-0.6,0.6-1.3,0.6-1.9c0.4,0.2,0.7,0.4,1.1,0.6
		c0.5,0.2,1,0.5,1.6,0.6c0,0,0,0,0.1,0c0.1,0.1,0.2,0.1,0.4,0c-0.2-0.3-0.4-0.6-0.6-0.8c-0.1-0.1-0.2-0.2-0.1-0.3
		c0-0.1,0-0.2-0.1-0.2c-0.4-0.1-0.8-0.2-0.9-0.7c0,0,0-0.1-0.1,0c-0.2,0.1-0.3,0.1-0.4,0c-0.2-0.1-0.3-0.2-0.5-0.3
		c-0.1-0.1-0.1-0.1,0-0.3c-0.4,0-0.4-0.1-0.3-0.5c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.2c-0.1,0-0.1-0.1,0-0.2
		c0.2-0.2,0.2-0.4,0.1-0.6c-0.1-0.4,0-0.9,0.3-1.4c0.1-0.1,0.1-0.1,0-0.2c-0.2-0.2-0.2-0.5,0-0.8c0-0.1,0.1-0.2,0.1-0.2
		c0.2-0.3,0.2-0.6,0.1-0.8c-0.1-0.3-0.1-0.3,0.2-0.4c0.1,0,0.1-0.1,0.2-0.1c0.4-0.1,0.9-0.1,1.3-0.2c0.5,0,1,0,1.5-0.3
		c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.3,0-0.3-0.1c-0.2-0.3-0.6-0.2-0.9-0.2c-0.1,0-0.3,0-0.3,0
		c-0.1-0.2-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0,0,0c0.1-0.2,0-0.1-0.1-0.1c-0.2,0-0.4-0.1-0.7-0.1c-0.7,0-1.5,0-2.3,0
		c0-0.1,0.1-0.1,0.1-0.1c-0.2,0-0.3-0.1-0.6,0c-0.1,0.1-0.1,0-0.2,0c-0.4,0-0.7,0-1.1,0.2c-0.1,0-0.1,0-0.1,0
		c-0.1-0.2-0.3-0.2-0.5-0.3c-0.1,0-0.2,0-0.2-0.1c0-0.1-0.1-0.1-0.2,0c-0.2,0-0.3,0.1-0.5,0.1C5.2,39.3,5.2,39,5,39.1
		c-0.1,0-0.1,0-0.2,0.1c0,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1,0c-0.6,0.2-1.1,0.2-1.6,0.1c-0.2-0.1-0.4,0-0.7,0.1
		C2,39.3,2,39.4,1.9,39.4z M3.1,41.1c0.7-0.2,1.4-0.3,2.1-0.3c1.3-0.1,2.5-0.1,3.8-0.1c0.1,0,0.2,0.1,0.2,0.2c0,0.2,0.1,0.4,0.1,0.6
		c0,1.3,0,2.6-0.1,3.9c0,0.2,0,0.2-0.3,0.3c-0.4,0-0.7-0.1-0.9-0.3c-0.1-0.1-0.1-0.2-0.3-0.2c0,0,0,0,0,0c0.1-0.3-0.2-0.2-0.4-0.3
		c0.1-0.1,0.1,0,0.2-0.2c0-0.1-0.1-0.1-0.1-0.1c-0.3-0.1-0.5-0.2-0.7-0.4c-0.3-0.2-0.5-0.4-0.9-0.5c0,0-0.1,0-0.1-0.1
		c0-0.1-0.1-0.2-0.2-0.3c0,0-0.3,0,0-0.2c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0-0.2,0-0.3,0c0.1-0.2,0.1-0.2,0-0.3
		c-0.3-0.2-0.7-0.4-1-0.5c-0.1,0-0.1-0.1,0-0.2c0.1-0.3,0.1-0.4-0.2-0.4c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3-0.2-0.1-0.4
		C2.9,41.1,3,41.1,3.1,41.1z"
      />
      <path
        id="XMLID_58_"
        d="M6,21.3c0.3,0.2,0.6,0.5,0.9,0.7c1.3,0.9,2.8,1.8,4.2,2.6c0,0,0.1,0,0.1,0.1c-0.1,0.1-0.1,0.1-0.2,0.1
		c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1,0c-0.1,0.1-0.2,0.2-0.3,0c0,0,0,0-0.1,0c-0.3,0.1-0.4-0.1-0.6-0.2c-0.2-0.1-0.3-0.1-0.6-0.1
		c-0.2,0.1-0.3,0-0.4-0.1c-0.1-0.2-0.2-0.2-0.4-0.2c-0.1,0-0.2,0-0.3-0.1c-0.5-0.3-1.1-0.4-1.6-0.8c-0.1-0.1-0.1-0.1-0.2-0.1
		c-0.2-0.1-0.4-0.2-0.5-0.4c0-0.1-0.1,0-0.2,0C5.1,23,4.9,23.5,4.7,24c-0.1,0.2,0,0.3,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.2
		c0.4,0.2,0.4,0.1,0.1,0.7c-0.3,0.5-0.6,0.9-0.9,1.4C4,27,4,27.4,4.3,27.6c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.3,0.2
		c0.2,0.2,0.4,0.3,0.6,0.4c1,0.5,2.1,0.8,3.2,0.9c0.3,0,0.5,0.2,0.7,0.4c0.5,0.6,1,1.1,1.6,1.7c0,0,0.1,0,0,0.1
		c0,0.1-0.1,0.1-0.2,0.1c-0.3,0.1-0.6,0-0.7-0.2c0,0-0.1-0.1-0.2,0c-0.2,0.1-0.3,0-0.4,0C9.3,31.2,9.1,31,8.8,31
		c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0-0.3,0-0.3-0.1c-0.1-0.2-0.2-0.2-0.4-0.2c0,0-0.1,0-0.1,0c-0.4-0.2-0.9-0.3-1.3-0.5
		c-0.2-0.1-0.4-0.3-0.6-0.3c-0.1,0-0.2,0-0.3,0.1c-0.3,0.3-0.5,0.7-0.7,1.1c-0.1,0.1-0.1,0.2,0,0.3c0.8,0.5,1.7,0.8,2.6,1
		c0.9,0.2,1.8,0.3,2.9,0.2c0.4-0.1,0.9-0.2,1.3-0.5c0.5-0.3,0.5-0.8,0.3-1c-0.2-0.2-0.5-0.3-0.6-0.6c0,0-0.1,0-0.1-0.1
		c-0.3-0.2-0.6-0.5-0.9-0.8c0,0-0.1,0,0-0.1c0-0.1,0.1,0,0.1,0c0.2,0,0.5,0,0.7,0.1c0.3,0,0.6-0.2,0.8-0.6c0-0.1,0.1-0.2,0.1-0.2
		c0.2-0.3,0.2-0.4,0-0.5c-0.7-0.5-1.4-0.9-2.1-1.4c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2,0-0.4-0.1-0.4-0.3c0,0-0.1,0-0.1-0.1
		c-0.4-0.1-0.8-0.4-1.1-0.8c0,0-0.1,0,0-0.1c0.3,0,0.6,0,0.9,0.1c0.5,0.1,1,0.2,1.5,0.2c0,0,0.1,0,0.1,0c0.5,0.2,1.1,0,1.7-0.4
		c0.3-0.2,0.4-0.7,0.2-0.9c-1.8-1.1-3.6-2.1-5.3-3.2c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.2,0-0.2-0.2c0,0-0.1,0-0.1,0
		C6.1,21.1,6,21.2,6,21.3z M9.4,27.5c0.5,0.3,0.9,0.7,1.4,1c0,0,0.1,0,0.1,0.1c-0.2,0.1-0.4,0-0.5,0c-0.5-0.1-0.9-0.2-1.3-0.4
		c0,0-0.1-0.1-0.1-0.1C9,28,8.9,27.9,8.7,28c0,0-0.1,0-0.1,0c-0.2-0.1-0.5-0.2-0.6-0.4c-0.2-0.2-0.4-0.3-0.7-0.5
		c-0.2-0.1-0.4-0.2-0.6-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.3-0.1-0.6-0.3-0.7-0.6c0,0,0,0,0-0.1c0.1-0.3,0.1-0.5,0.2-0.8
		c0.1-0.1,0.1-0.2,0.2-0.1C7.2,25.7,8.3,26.6,9.4,27.5z"
      />
    </g>
  </svg>
);

export const utilityLogoMatlib = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 105 50"
    width="105"
    height="60"
  >
    <g id="_x3C_Group_x3E_">
      <g id="csi-logo-bottom">
        <path
          className="st0"
          d="M31.5,24.9c-1.3,0.6-2.8,0.9-4.5,0.9c-1.6,0-3-0.3-4.3-0.8c-1.3-0.5-2.5-1.2-3.4-2.2c-1-0.9-1.7-2.1-2.3-3.4
			  c-0.6-1.3-0.8-2.8-0.8-4.3c0-1.6,0.3-3.1,0.8-4.4c0.6-1.3,1.3-2.4,2.3-3.4c1-0.9,2.2-1.6,3.5-2.1C24,4.7,25.5,4.5,27,4.5
			  c1.4,0,2.8,0.3,4.2,0.8s2.5,1.2,3.4,2.2l-3.3,3.3c-0.5-0.6-1.1-1.1-1.8-1.4c-0.7-0.3-1.5-0.5-2.3-0.5c-0.9,0-1.6,0.2-2.4,0.5
			  c-0.7,0.3-1.3,0.7-1.8,1.3c-0.5,0.6-0.9,1.2-1.2,2c-0.3,0.8-0.4,1.6-0.4,2.5c0,0.9,0.1,1.8,0.4,2.5c0.3,0.8,0.7,1.4,1.2,2
			  c0.5,0.5,1.1,1,1.8,1.3c0.7,0.3,1.5,0.5,2.3,0.5c1,0,1.8-0.2,2.5-0.6c0.7-0.4,1.3-0.9,1.7-1.5l3.4,3.2
			  C33.9,23.5,32.8,24.3,31.5,24.9z"
        />
        <path
          className="st0"
          d="M47.6,10.3c-0.4-0.5-1-1-1.6-1.3c-0.7-0.3-1.3-0.5-2-0.5c-0.3,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3
			  c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2,0.3-0.3,0.6-0.3,1c0,0.3,0.1,0.6,0.2,0.9c0.1,0.2,0.4,0.4,0.6,0.6c0.3,0.2,0.6,0.3,1,0.5
			  c0.4,0.1,0.8,0.3,1.3,0.4c0.7,0.2,1.4,0.5,2.1,0.8c0.7,0.3,1.4,0.6,2,1.1c0.6,0.5,1.1,1,1.5,1.7c0.4,0.7,0.6,1.5,0.6,2.5
			  c0,1.2-0.2,2.2-0.6,3c-0.4,0.8-1,1.6-1.7,2.1c-0.7,0.6-1.6,1-2.5,1.2c-0.9,0.3-1.9,0.4-2.9,0.4c-1.4,0-2.9-0.3-4.2-0.8
			  c-1.4-0.5-2.5-1.2-3.4-2.2l3.2-3.3c0.5,0.6,1.1,1.1,2,1.5c0.8,0.4,1.6,0.6,2.4,0.6c0.4,0,0.7,0,1.1-0.1c0.3-0.1,0.6-0.2,0.9-0.4
			  c0.3-0.2,0.5-0.4,0.6-0.7c0.2-0.3,0.2-0.6,0.2-1c0-0.4-0.1-0.7-0.3-1c-0.2-0.3-0.5-0.5-0.8-0.7c-0.4-0.2-0.8-0.4-1.3-0.6
			  c-0.5-0.2-1.1-0.4-1.8-0.6c-0.6-0.2-1.3-0.5-1.9-0.7c-0.6-0.3-1.2-0.7-1.7-1.1c-0.5-0.4-0.9-1-1.2-1.6c-0.3-0.6-0.4-1.4-0.4-2.3
			  c0-1.1,0.2-2.1,0.7-2.9c0.5-0.8,1.1-1.5,1.8-2c0.7-0.5,1.6-0.9,2.5-1.1c0.9-0.2,1.9-0.4,2.8-0.4c1.1,0,2.3,0.2,3.5,0.6
			  c1.2,0.4,2.2,1,3.1,1.9L47.6,10.3z"
        />
        <path className="st0" d="M53.8,25.3V5h4.9v20.3H53.8z" />
      </g>
      <g id="csi-logo-bottom">
        <path
          className="st0"
          d="M33.5,41.3c-0.4,1-1,1.9-1.8,2.6c-0.8,0.7-1.7,1.3-2.8,1.7c-1.1,0.4-2.3,0.6-3.6,0.6c-1.3,0-2.5-0.2-3.6-0.6
			  c-1.1-0.4-2-1-2.7-1.7s-1.3-1.6-1.7-2.6c-0.4-1-0.6-2.1-0.6-3.3V25.3h4.9v12.2c0,0.6,0.1,1.1,0.2,1.6c0.1,0.5,0.4,0.9,0.7,1.3
			  c0.3,0.4,0.7,0.7,1.2,0.9c0.5,0.2,1.1,0.3,1.8,0.3s1.3-0.1,1.8-0.3c0.5-0.2,0.9-0.5,1.2-0.9c0.3-0.4,0.5-0.8,0.7-1.3
			  c0.1-0.5,0.2-1,0.2-1.6V25.3h4.9v12.6C34.1,39.1,33.9,40.3,33.5,41.3z"
        />
        <path
          className="st0"
          d="M42.9,34.8v5.5c0,0.7,0.1,1.2,0.4,1.5c0.3,0.3,0.7,0.5,1.4,0.5c0.2,0,0.5,0,0.7-0.1c0.3,0,0.5-0.1,0.6-0.2
			  l0.1,3.4c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-1,0.1-1.5,0.1c-1,0-1.8-0.1-2.4-0.4c-0.6-0.2-1.2-0.6-1.6-1c-0.4-0.4-0.7-1-0.8-1.6
			  c-0.2-0.6-0.3-1.3-0.3-2.1v-6h-2.3v-3.5h2.3v-3.7h4.6v3.7h3.3v3.5H42.9z"
        />
        <path
          className="st0"
          d="M53.6,26.8c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.2,0.2-0.5,0.4-0.9,0.5c-0.3,0.1-0.7,0.2-1,0.2
			  c-0.8,0-1.4-0.3-1.9-0.8c-0.5-0.5-0.8-1.1-0.8-1.8c0-0.3,0.1-0.7,0.2-1c0.1-0.3,0.3-0.6,0.6-0.8c0.2-0.2,0.5-0.4,0.9-0.6
			  c0.3-0.1,0.7-0.2,1.1-0.2c0.4,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8C53.5,26.1,53.6,26.4,53.6,26.8z
			   M48.5,45.6V31.3h4.7v14.2H48.5z"
        />
        <path className="st0" d="M57,45.6V23.9h4.8v21.6H57z" />
        <path
          className="st0"
          d="M70.6,26.8c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.2,0.2-0.5,0.4-0.9,0.5c-0.3,0.1-0.7,0.2-1,0.2
			  c-0.8,0-1.4-0.3-1.9-0.8c-0.5-0.5-0.8-1.1-0.8-1.8c0-0.3,0.1-0.7,0.2-1c0.1-0.3,0.3-0.6,0.6-0.8c0.2-0.2,0.5-0.4,0.9-0.6
			  c0.3-0.1,0.7-0.2,1.1-0.2c0.4,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8C70.5,26.1,70.6,26.4,70.6,26.8z
			   M65.5,45.6V31.3h4.7v14.2H65.5z"
        />
        <path
          className="st0"
          d="M79,34.8v5.5c0,0.7,0.1,1.2,0.4,1.5c0.3,0.3,0.7,0.5,1.4,0.5c0.2,0,0.5,0,0.7-0.1c0.3,0,0.5-0.1,0.6-0.2
			  l0.1,3.4c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-1,0.1-1.5,0.1c-1,0-1.8-0.1-2.4-0.4c-0.6-0.2-1.2-0.6-1.6-1c-0.4-0.4-0.7-1-0.8-1.6
			  c-0.2-0.6-0.3-1.3-0.3-2.1v-6h-2.3v-3.5h2.3v-3.7H79v3.7h3.3v3.5H79z"
        />
        <path
          className="st0"
          d="M92.6,47.7c-0.3,0.7-0.6,1.4-1,2c-0.4,0.6-0.8,1.1-1.3,1.5c-0.5,0.4-1.1,0.7-1.7,0.9
			  c-0.7,0.2-1.4,0.3-2.3,0.3c-0.4,0-0.9,0-1.4-0.1c-0.5-0.1-0.9-0.1-1.2-0.2l0.5-3.9c0.2,0.1,0.5,0.1,0.8,0.2c0.3,0,0.5,0.1,0.8,0.1
			  c0.7,0,1.2-0.2,1.6-0.5c0.3-0.3,0.6-0.8,0.8-1.4l0.5-1.2l-6-14h5.2l3.2,9.2h0.1l2.8-9.2h5L92.6,47.7z"
        />
      </g>
    </g>
    <g id="csi-logo-asiatan">
      <path
        id="XMLID_5_"
        className="st1"
        d="M11.7,27.3L11.7,27.3c-0.2,1.1-1.3,1.7-3.5,1.7c-0.6,0-1.6-0.1-2.9-0.3C3.6,28.4,3,28.2,2.8,28
			l-0.1,0l-0.1,0C2.3,28,2,28.4,2,30.5v0c0.1,0.3,0.2,0.6,0.8,0.7c0.2,0,0.4,0,0.6,0c0.1,0,0.2,0,0.3,0c1.2,0.4,2.5,1.1,4,2
			c2.2,1.4,2.5,1.8,2.5,2c0,0.5-0.7,0.9-1.9,1.2c-0.6,0.2-1.2,0.3-1.8,0.4c-0.6,0.1-1.3,0.1-2.1,0.1c-1.2,0-1.7-0.1-1.9-0.3
			l-0.1-0.1l-0.1,0.2c-0.4,0.8-0.5,1.5-0.5,1.9c0,0.9,0.5,1.1,0.9,1.1c1,0,2.2,0.4,3.6,1.2c1.4,0.7,2.5,1.6,3.5,2.6
			c0.3,0.3,0.5,0.6,0.7,0.9h0l0.1,0.2c0.3,0.5,0.4,1,0.4,1.4c0,0.2,0,0.4,0,0.8c0,0.3-0.1,0.7-0.1,1.2l0,0l0.3,0.8l0.2-0.2
			c0.5-0.7,0.8-1.6,0.8-2.5c0-2.5-1.6-4.6-4.9-6.4c-0.6-0.3-1-0.5-1.3-0.7c1.2-0.3,1.5-0.3,1.6-0.4c0.2-0.1,0.4-0.1,0.6-0.1
			c0.2,0,0.3,0,0.4-0.1h0c2.1-0.6,3.1-1.6,3.1-3c0-1.1-1-2.3-3.1-3.3l-0.5-0.3c-0.5-0.3-0.9-0.5-1.3-0.7c-0.2-0.1-0.4-0.2-0.5-0.3
			l0.1,0c0.1,0,0.3,0,0.4,0c0.2,0,0.4,0,0.6,0h0.4c0.9,0,1.8-0.1,2.7-0.5c1.5-0.5,2.3-1.3,2.3-2.5c0-0.3-0.1-0.6-0.4-0.8L12,27
			L11.7,27.3z"
      />
      <g id="XMLID_2_">
        <path
          id="XMLID_4_"
          className="st1"
          d="M4.2,13.3c0.2-0.3,0.2-0.6,0.2-0.9c0-0.8-0.5-0.9-0.8-0.9c-0.4,0-0.8,0.2-0.8,1.1
				c0,0.2,0.1,0.5,0.2,0.7c0.2,0.3,0.3,0.4,0.5,0.4C3.9,13.7,4.1,13.5,4.2,13.3z"
        />
        <path
          id="XMLID_3_"
          className="st1"
          d="M6.1,8c0,0.5,0.1,0.8,0.4,1.2C6.3,9.1,6,9.1,5.8,9C5.2,8.9,4.5,8.7,3.8,8.5c0,0-0.1,0-0.1,0
				h0.2l-1-0.3C2.7,8.1,2.6,8,2.4,8C2.2,8,1.8,8.1,1.8,8.9v0.1c0,0.5,0.2,0.7,0.3,0.8L2.2,10l0.1-0.1c0,0,0.1,0,0.1,0
				c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l3,0.6c0.6,0.1,1.1,0.2,1.7,0.3c0.4,0.2,0.8,0.3,1,0.5l1.4,0.7c0.5,0.3,0.6,0.5,0.6,0.5
				c0,0.1,0,0.3-0.6,0.3c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.7-0.2-1.1-0.3l-0.9-0.3h0c-0.3,0-0.5,0.3-0.5,0.9c0,0.3,0.1,0.5,0.2,0.8
				l0,0.1h0.1L7.6,14h0c0.1,0,0.2,0.1,0.3,0.1l0,0l0,0l0,0l0,0c2.2,1,2.6,1.6,2.6,1.8c0,0.1-0.1,0.3-0.3,0.7
				c-0.3,0.4-0.8,0.6-1.4,0.6c0,0-0.1,0-0.1-0.1l0,0l0,0c0,0,0,0,0,0l0-0.1l0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0l0,0c0,0,0,0,0,0v0
				c-0.3-0.4-0.7-0.7-1.1-1c-0.4-0.3-0.9-0.6-1.5-0.9c-1.1-0.5-2-0.8-2.8-0.8c-1.4,0-1.7,1-1.7,1.9c0,0.5,0.2,1.1,1.2,1.2h0
				c0.5,0.3,1,0.5,1.5,0.7c0,0.1,0,0.3,0,0.3s0.1,0.6,0.1,0.6l0,0c0,0.1,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2v0.5c-0.1,0-0.1,0-0.1,0
				c0,0-0.1,0-0.1,0c-0.1-0.1-0.2-0.1-0.3-0.1H3.1l0,0.1c-0.2,0.5-0.3,1-0.3,1.3c0,0.3,0.1,0.5,0.3,0.6l0.1,0l0.3-0.1
				c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.2,0s0,0,0,0c0,0.7,0,1.2,0,1.6c0,0.5,0,1,0,1.5c0,0.5,0.1,0.7,0.4,0.7c0.2,0,0.4-0.2,0.4-0.5
				c0-0.2,0.1-0.3,0.2-0.5l0,0l-0.1-0.8c0-0.6,0-1,0-1.4c0-0.2,0-0.4,0-0.5c1,0.2,1.9,0.3,2.5,0.4l0.1,0c2.6,1.1,2.8,1.6,2.8,1.7
				c0,0.2-0.2,0.3-0.7,0.3H9.7c-0.6,0-1.5-0.3-2.4-0.8l-0.2-0.1l-0.2,1.1l-0.4,0.3C6.2,24.9,6,25.4,6,26.3c0,0.5,0.5,1,1.6,1.5
				c0.8,0.4,1.4,0.6,1.8,0.6h0.2c0.9,0,2-0.3,2-1.7c0-0.7-0.3-1.2-0.8-1.6c0.4-0.4,0.6-0.9,0.6-1.4c0-0.6-0.4-1.1-1.3-1.7
				c0,0,0,0,0,0c0.7-0.3,1.1-0.9,1.1-1.6c0-0.7-0.4-1.3-1.3-1.9c0.1-0.1,0.3-0.1,0.4-0.2c0.8-0.5,1.1-1.3,1.1-2.2
				c0-0.6-0.4-1.3-1.2-1.9c0.7-0.2,1-0.7,1-1.5c0-0.6-0.2-1-0.7-1.4l0,0c0,0,0,0,0,0c0.2,0,0.3-0.1,0.5-0.3c0.1-0.2,0.2-0.4,0.2-0.6
				c0-0.1,0-0.3-0.1-0.4c0.3-0.3,0.5-0.7,0.5-1.1c0-0.9-0.6-1.5-1.9-2C9.5,6.5,9.1,6.4,8.7,6.3C8.3,6.2,8,6.2,7.6,6.2
				C6.4,6.2,6.1,7.2,6.1,8z M7.9,7.7c0.7,0,1.4,0.2,2.2,0.5c0.6,0.3,0.7,0.5,0.7,0.6c0,0.1,0,0.1-0.1,0.2l0,0
				c-0.1,0.1-0.3,0.3-0.4,0.5c-0.4,0-1-0.2-1.8-0.6C7.2,8.3,7,8,7,7.9C7.1,7.9,7.1,7.7,7.9,7.7z M6.8,17.1c-1-0.2-2.2-0.7-3.6-1.4
				c0.1,0,0.2,0,0.4,0c0.5,0,1.2,0.2,2,0.7c0.3,0.2,0.6,0.4,0.9,0.6C6.6,17,6.7,17,6.8,17.1z M4.1,21.3L4.1,21.3
				C4.1,21.3,4.1,21.3,4.1,21.3L4.1,21.3z M5.1,18.3c1,0.3,2,0.4,3.1,0.5c1.9,0.8,2.1,1.3,2.1,1.5c0,0.2-0.4,0.3-0.6,0.3
				c-0.1,0-0.3,0-0.5,0c-0.2,0-0.6,0-1,0c-0.4,0-0.8,0-1.3-0.1c-0.5-0.1-1.1-0.2-1.8-0.4l0-0.4c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0-0.3
				v-0.5c0-0.1,0-0.2,0-0.2C5.1,18.5,5.1,18.4,5.1,18.3z M10.8,26.7c0,0.1-0.1,0.2-0.4,0.2c-0.8,0-1.4-0.1-1.9-0.4
				c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.2-0.1-0.3-0.1l-0.1-0.1c-0.4-0.3-0.5-0.4-0.5-0.4c0,0,0.1-0.1,0.4-0.2l0,0l0.2-0.2l1.1,0.2
				c0.1,0,0.3,0.1,0.4,0.2c0.2,0.1,0.4,0.2,0.6,0.3C10.5,26.3,10.7,26.5,10.8,26.7z"
        />
      </g>
    </g>
  </svg>
);
